module.exports = __webpack_public_path__ + "static/img/forUsBanner.3cbf634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/forUsBanner.png
// module id = rdEl
// module chunks = 1